//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateRutasPesaje } from "@/typings/store/plugins/easyFirestore/rutasPesaje";

const getters: GetterTree<StateRutasPesaje, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const rutasPesaje = {
  firestorePath: "{env}/v1/empresas/{idEmpresa}/rutasPesaje",
  firestoreRefType: "collection",
  moduleName: "rutasPesaje",
  statePropName: "all",
  namespaced: true,

  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default rutasPesaje;
